module.exports = __webpack_public_path__ + "img/past-events_world-series.b350f545.jpg";